import config from "../config";
import SessionUtil from "./SessionUtil";

export default class ApiUtil {
  static baseURL = config.API_URL;
  static postApi = async (path, params = {}, method) => {
    try {
      const token = SessionUtil.getToken(); // Call the apiKey function and wait for its result
      const response = await fetch(`${ApiUtil.baseURL}/${path}`, {
        method: method,
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
        body: JSON.stringify(params),
      });
      if (!response.ok) {
        console.log(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    } catch (error) {
      console.error("Error:", error);
      // throw error; // Re-throw the error to propagate it up the call stack
    }
  };

  static getApi = async (path, method) => {
    try {
      const token = SessionUtil.getToken(); // Call the apiKey function and wait for its result
      const response = await fetch(`${ApiUtil.baseURL}/${path}`, {
        method: "GET",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        console.log(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    } catch (error) {
      console.error("Error:", error);
      // throw error; // Re-throw the error to propagate it up the call stack
    }
  };
}
